var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypescripts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007ACC",
    d: "M0 14.508v-14h28v28H0v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.139 14.555v1.142h3.639v10.36h2.584v-10.36H16v-1.121c0-.63 0-1.142-.028-1.155 0-.02-2.22-.028-4.915-.028l-4.899.02v1.15l-.02-.008Zm16.358-1.169a3.4 3.4 0 0 1 1.75 1c.26.281.645.77.672.896 0 .041-1.21.862-1.946 1.317-.027.02-.139-.098-.253-.28-.364-.517-.736-.743-1.317-.784-.84-.057-1.399.385-1.399 1.119 0 .223.041.35.126.53.189.386.54.616 1.624 1.092 2.003.862 2.871 1.43 3.395 2.24.595.91.727 2.338.328 3.41-.448 1.168-1.54 1.959-3.1 2.219-.49.084-1.612.07-2.136-.021-1.119-.21-2.192-.77-2.848-1.49-.26-.28-.757-1.03-.727-1.078l.267-.169 1.05-.608.79-.463.183.247c.23.364.75.854 1.05 1.023.91.469 2.129.405 2.73-.14.26-.236.372-.49.372-.84 0-.322-.05-.47-.21-.713-.223-.308-.672-.561-1.932-1.12-1.45-.614-2.065-1.006-2.639-1.61-.328-.365-.629-.932-.77-1.4-.105-.405-.139-1.398-.041-1.8.3-1.398 1.358-2.378 2.871-2.659.49-.098 1.645-.057 2.128.071l-.018.011Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    y: 0.508,
    fill: "#fff",
    rx: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescripts);
export default __webpack_public_path__ + "static/media/Typescripts.3a18d6392e772823f812f685da36abc5.svg";
export { ForwardRef as ReactComponent };